var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from "@filadd/phi-plus-styled-system/css";
import { useRef, useState } from "react";
import { useResizeObserver } from "usehooks-ts";
import { Logo } from "./Logo";
import { MenuItem } from "./MenuItem";
import { ReleaseSelector } from "./ReleaseSelector";
import { useGroupedFeatures } from "./groupFeaturesBySection";
import { sideNavRecipe } from "./recipes";
import { SectionMenuItem } from "./SectionMenuItem";
import { Toggle } from "./Toggle";
export const SideNav = (_a) => {
    var { releases, layoutFeatures, className, open, onToggle } = _a, releaseSelectorProps = __rest(_a, ["releases", "layoutFeatures", "className", "open", "onToggle"]);
    const features = useGroupedFeatures(layoutFeatures);
    const topLayoutFeatures = features.filter((feature) => feature.disposition === "NAVBAR_TOP");
    const bottomLayoutFeatures = features.filter((feature) => feature.disposition === "NAVBAR_BOTTOM");
    const topNavRef = useRef(null);
    const [topNavHasScrollbar, setTopNavHasScrollbar] = useState(false);
    useResizeObserver({
        ref: topNavRef,
        onResize: () => {
            if (topNavRef.current) {
                setTopNavHasScrollbar(topNavRef.current.scrollHeight > topNavRef.current.clientHeight);
            }
        },
    });
    const styles = sideNavRecipe({ collapsed: !open });
    return (_jsx("div", { className: cx(styles.root, className), children: _jsxs("div", { className: styles.container, children: [onToggle != null && (_jsx("div", { className: styles.toggleBox, children: _jsx(Toggle, { open: open, onClick: onToggle }) })), _jsx("div", { className: styles.logoBox, children: _jsx(Logo, { open: open }) }), releases.length > 0 && (_jsx("div", { className: styles.subheaderBox, children: open && (_jsx(ReleaseSelector, Object.assign({}, releaseSelectorProps, { releases: releases, layoutFeatures: layoutFeatures }))) })), topLayoutFeatures.length > 0 && (_jsx("nav", { className: styles.topNav, ref: topNavRef, children: topLayoutFeatures.map((item) => "items" in item ? (_jsx(SectionMenuItem, { section: item, displayText: open, hasScrollbar: topNavHasScrollbar }, item.title)) : (_createElement(MenuItem, Object.assign({}, item, { displayText: open, key: item.name, hasScrollbar: topNavHasScrollbar })))) })), bottomLayoutFeatures.length > 0 && (_jsx("div", { className: styles.bottomNav, children: bottomLayoutFeatures.map((item) => "items" in item ? (_jsx(SectionMenuItem, { section: item, displayText: open }, item.title)) : (_createElement(MenuItem, Object.assign({}, item, { displayText: open, key: item.name })))) }))] }) }));
};
//# sourceMappingURL=SideNav.js.map